import { SORT_ORDER } from '../constants';

function sortDomains(domainEntries, sort) {
  const { key, order } = sort;
  const sortParameter = key.includes('_rank') ? 'rank' : 'score';
  const sortKey = key.split('_rank')[0];

  return domainEntries.slice().sort((data0, data1) => {
    const score0 = data0[sortKey]?.[sortParameter];
    const score1 = data1[sortKey]?.[sortParameter];
    const orderFactor = order === SORT_ORDER.ASC ? 1 : -1;
    if (score0 > score1) {
      return orderFactor;
    }
    if (score0 < score1) {
      return -orderFactor;
    }
    return 0;
  });
}

export default sortDomains;
